import React from "react";
import { Link } from "react-router-dom";
import { Home } from "lucide-react";

export default function NotFound() {
  return (
    <section className="min-h-[60vh] flex items-center justify-center container-page">
      <div className="text-center max-w-md">
        <div className="font-serif text-7xl md:text-8xl font-bold text-brand-primary">404</div>
        <h2 className="font-serif text-2xl md:text-3xl font-bold text-brand-text mt-4">Page Not Found</h2>
        <p className="text-brand-muted mt-3">The page you're looking for doesn't exist or has been moved.</p>
        <Link to="/" className="btn-primary mt-8" data-testid="notfound-home"><Home size={16} /> Go to Homepage</Link>
      </div>
    </section>
  );
}
